import { createStyles, Divider, Grid, Theme, withStyles, WithStyles } from '@material-ui/core'
import moment from 'moment'
import * as R from 'ramda'
import React from 'react'

import { CompletionStatus, ParticipantOutcome, SupportiveService } from '../../../services/Model/Outcome'
import { mapToYesOrNoWithNullable, mapYesNoUnknownToBool } from '../../../services/utils'
// tslint:disable-next-line:max-line-length
import ActivityInformationSection from '../../FormTemplates/OutcomesActivityInformationSection/OutcomesActivityInformationSection'
import OutcomesFormActions from '../../FormTemplates/OutcomesFormActions/OutcomesFormActions'
import AcademicAwardDetails from '../FormItems/AcademicAwardDetails'
import CredentialsEarned from '../FormItems/CredentialsEarned'
import IncumbentWorkersInfoSection from '../FormItems/IncumbentWorkersInfoSection'
import SupportedServicesSection from '../FormItems/SupportedServices/SupportedServicesSection'
import TrainingHours from '../FormItems/TrainingHours'
import { getOutcomesAccordingToStatus, setInitialState, validateForm } from '../formUtils'
import SkillGainedSection from '../FormItems/SkillGainedSection/SkillGainedSection'
import CredentialSection from '../FormItems/CredentialSection/CredentialSection'

interface WTIWProps extends WithStyles<typeof styles> {
	outcomes: ParticipantOutcome
	onSubmit: (outcomes: ParticipantOutcome) => void
  employers: any[]
  onLocalOutcomesUpdate: (outcomes: ParticipantOutcome) => void
  outcomesCopy: ParticipantOutcome
}

interface WTIWState {
	localOutcomes: ParticipantOutcome
}

const TOP_START_DATE = new Date()

export class WorkforceTrainingIncumbentWorkers extends React.Component<WTIWProps, WTIWState> {
	public readonly state: WTIWState = setInitialState(this.props)
	formRef: React.RefObject<HTMLFormElement> = React.createRef()

	onFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		const isBulk = this.state.localOutcomes.participantEnrollmentType === 2
		const isFormValid = isBulk || validateForm(this.formRef)

		if (isFormValid) {
			this.props.onSubmit(this.state.localOutcomes)
		}
	}

	onCancel = () => {
		this.updateLocalOutcomes(this.props.outcomes)
	}

	updateLocalOutcomes = (outcomes: ParticipantOutcome) => {
		this.setState({
			localOutcomes: outcomes,
		})
    this.props.onLocalOutcomesUpdate(outcomes)
	}

	handleDateChange = (prop: string, value: Date | string) => {
		const updatedOutcomes = { ...this.state.localOutcomes, [prop]: moment(value).format("YYYY-MM-DD") }

		this.setState({
			localOutcomes: updatedOutcomes,
		})
	}

	handleTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
		const { name, value } = e.target
    console.log(`name7=${name}, value=${value}`)
		const updatedOutcomes = { ...this.state.localOutcomes, [name]: value }
    if(name === 'jobPlacementEmployerState' && value == 'RI'){
      updatedOutcomes.jobPlacementEmployerCity = ''
      updatedOutcomes.jobPlacementEmployerZipcode = ''
    }
		this.updateLocalOutcomes(updatedOutcomes)
	}

	handleCompletionStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = e.target
		const { localOutcomes } = this.state
		const updatedOutcomes = getOutcomesAccordingToStatus(value, localOutcomes)

		this.updateLocalOutcomes(updatedOutcomes)
	}

	yesNoDropDownHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
		const { name, value } = e.target
		const { localOutcomes } = this.state

		this.updateLocalOutcomes({ ...localOutcomes, [name]: mapYesNoUnknownToBool(value) })
	}

	componentDidMount(): void {
		window.scrollTo(0, 0)
	}

	handleServicesChange = (services: SupportiveService[]) => {
		const { localOutcomes } = this.state;

		this.updateLocalOutcomes({
			...localOutcomes,
			services
		})
	}

	handleSupportiveServices = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = e.target
		const { localOutcomes } = this.state
		const serviceProvided = mapYesNoUnknownToBool(value)

		const resetServicesProvided = {
			...localOutcomes,
			serviceProvided,
			serviceStartDate: null,
			serviceEndDate: null,
			services: []
		}

		this.updateLocalOutcomes(serviceProvided ? { ...localOutcomes, serviceProvided } : resetServicesProvided)

	}

	componentWillReceiveProps(nextProps: WTIWProps) {
		if (R.equals(this.props.outcomes, nextProps.outcomes)) return

		this.setState((prevState: WTIWState) => ({ ...prevState, localOutcomes: nextProps.outcomes }))
	}

  /* handleDateSkillAttainedChanged = (dateSkillAttained) =>{
    const { localOutcomes } = this.state;

		this.updateLocalOutcomes({
			...localOutcomes,
			dateSkillAttained
		})
  }

  handleMeasurableSkillGainChange = (measurableSkillGain) =>{
    const { localOutcomes } = this.state;
    const newOutcome:any = {
      ...localOutcomes,
			measurableSkillGain
    }
    if(!measurableSkillGain || measurableSkillGain.toLowerCase() === 'unknown'){
      newOutcome.dateSkillAttained= null
    }
		this.updateLocalOutcomes(
			newOutcome
		)
  } */

	render() {
		const { classes } = this.props
		const { localOutcomes } = this.state
		const isBulk = localOutcomes.participantEnrollmentType === 2

		return (
			<div className={classes.root} data-auto="form-wrapper">
				<Divider variant="middle" style={{ margin: '15px 0' }} />
				<form onSubmit={this.onFormSubmit} ref={this.formRef}>
					<div>
						<ActivityInformationSection
							// Removed: Outcome Actual Start Date — no longer collected
							// startDate={localOutcomes.startDate || undefined}
							endDate={localOutcomes.completionDate || undefined}
							minEndDate={localOutcomes.startDate ? moment(localOutcomes.startDate).format('YYYY-MM-DD') : ''}
							// requiredStartDate={!isBulk}
							requiredEndDate={isBulk ? false : localOutcomes.completionStatus !== CompletionStatus.ENROLLED}
							onDateChange={this.handleDateChange}
							// maxStartDate={moment(TOP_START_DATE).format('YYYY-MM-DD')}
							showEndDate={localOutcomes.completionStatus !== CompletionStatus.ENROLLED}
							completionStatus={localOutcomes.completionStatus}
							handleCompletionStatusChange={this.handleCompletionStatusChange}
							dropReason={localOutcomes.dropReason || ''}
							onDropReasonChange={this.handleTextChange}
						/>
						<TrainingHours trainingHours={localOutcomes.trainingHours || ''} onChange={this.handleTextChange} />
					</div>
					<Divider variant="middle" style={{ margin: '15px 0' }} />
					<div>
						<IncumbentWorkersInfoSection
							incumbentEmployer={localOutcomes.incumbentEmployer || ''}
							handleIncumbentEmployerChange={this.handleTextChange}
							jobPlacementIndustry={localOutcomes.jobPlacementIndustry || ''}
							handleIndustryChange={this.handleTextChange}
							wageIncreaseStringVal={mapToYesOrNoWithNullable(localOutcomes.wageIncrease)}
							handleWageIncreaseChange={this.yesNoDropDownHandler}
							promotionStringVal={mapToYesOrNoWithNullable(localOutcomes.promotion)}
							handlePromotionChange={this.yesNoDropDownHandler}
							positionBackfilledStringVal={mapToYesOrNoWithNullable(localOutcomes.positionBackfilled)}
							handlePositionBackfilledChange={this.yesNoDropDownHandler}
              employers={this.props.employers}
						/>
					</div>
					<Divider variant="middle" style={{ margin: '15px 0' }} />
					<div>
          <Grid className={classes.block} container={true} spacing={8}>
              <CredentialSection
                index={1}
              />
              <CredentialSection
                index={2}
              />
          </Grid>
						<AcademicAwardDetails onChange={this.handleTextChange} value={localOutcomes.academicAwardDetail || ''} />
					</div>
					<Divider variant="middle" style={{ margin: '15px 0' }} />
					<div>
						<SupportedServicesSection
							isServiceProvided={localOutcomes.serviceProvided}
							startDate={localOutcomes.serviceStartDate}
							endDate={localOutcomes.serviceEndDate}
							supportiveServices={localOutcomes.services}
							updateServices={this.handleServicesChange}
							handleServiceStartDateChange={({ target }) => this.handleDateChange('serviceStartDate', target.value)}
							handleServiceEndDateChange={({ target }) => this.handleDateChange('serviceEndDate', target.value)}
							handleServiceProvidedChange={this.handleSupportiveServices}
						/>
					</div>
          {/* <Divider variant="middle" style={{ margin: '15px 0' }} />
          <div>
          <SkillGainedSection 
              outcomes={localOutcomes}
              handleDateSkillAttainedChanged={this.handleDateSkillAttainedChanged}
              handleMeasurableSkillGainChange={this.handleMeasurableSkillGainChange}
            />
          </div> */}
					<Divider variant="middle" style={{ margin: '15px 0' }} />
					<OutcomesFormActions
						onCancel={this.onCancel}
						isSubmitDisabled={R.equals(this.props.outcomesCopy, this.state.localOutcomes)}
					/>
				</form>
			</div>
		)
	}
}

const styles = (theme: Theme) =>
	createStyles({
		root: {},
    block:{
      display: 'block'
    }
	})

export default withStyles(styles)(WorkforceTrainingIncumbentWorkers)
